import { ProductOptionValues } from './ProductType.ts';

export const getWeightLabel = (
  boxWeight: string,
  quantity: number,
  purchaseOption: ProductOptionValues,
  productType?: string
): string => {
  if (!boxWeight || !quantity) return '';

  const cleanedWeights = boxWeight
    .replace(/\s/g, '')
    .split(/[-/]/)
    .map((w) => Number(w))
    .filter((w) => !isNaN(w));

  if (cleanedWeights.length === 0) return '';

  let stringLabel = '';
  let suffix = '';
  let prefix = '';

  const formatWeight = (w: number) =>
    Number.isInteger(w) ? w : parseFloat(w.toFixed(2));

  if (productType?.toLowerCase() === 'otros') {
    const unitsPerMaple = 30;

    switch (purchaseOption) {
      case ProductOptionValues.FULL_CRATE:
        return `${12 * quantity} maples x ${unitsPerMaple}u`;

      case ProductOptionValues.HALF_CRATE:
        return `${6 * quantity} maples x ${unitsPerMaple}u`;

      case ProductOptionValues.MAPLE:
        return `${1 * quantity} maple${
          quantity > 1 ? 's' : ''
        } x ${unitsPerMaple}u`;

      default:
        break; // Si hay otro tipo, sigue con el flujo normal
    }
  }

  // 👇 Prioridad especial para condimentos
  if (productType?.toLowerCase() === 'condimentos') {
    const weight = formatWeight(cleanedWeights[0] * quantity);
    return `peso: ${weight} kg`;
  }

  switch (purchaseOption) {
    case ProductOptionValues.HALF_CRATE:
      stringLabel = cleanedWeights
        .map((w) => formatWeight((w / 2) * quantity))
        .join('-');
      prefix = 'peso:';
      suffix = 'kg';
      break;

    case ProductOptionValues.KG:
      stringLabel = cleanedWeights
        .map((w) => formatWeight(w * quantity))
        .join('-');
      prefix = 'peso:';
      suffix = 'kg';
      break;

    case ProductOptionValues.GR:
      stringLabel = cleanedWeights
        .map((w) => formatWeight(w * quantity))
        .join('-');
      prefix = 'peso:';
      suffix = 'gr';
      break;

    case ProductOptionValues.LT:
      stringLabel = cleanedWeights
        .map((w) => formatWeight(w * quantity))
        .join('-');
      prefix = 'peso:';
      suffix = 'lts';
      break;

    case ProductOptionValues.UNIT:
    case ProductOptionValues.PACK:
      stringLabel = cleanedWeights
        .map((w) => formatWeight(w * quantity))
        .join('-');
      suffix =
        purchaseOption === ProductOptionValues.UNIT ? 'unidad' : 'paquete';
      break;

    default:
      stringLabel = cleanedWeights
        .map((w) => formatWeight(w * quantity))
        .join('-');
      prefix = 'peso:';
      suffix = 'kg';
      break;
  }

  return `${prefix} ${stringLabel} ${suffix}`.trim();
};
